<footer fxLayout="row" class="bg-color-maastricht-blue" fxLayoutAlign="center center">
  <div
    fxFlex="80"
    fxLayout="row"
    fxLayout.xs="column"
    fxLayout.sm="column"
    fxLayoutGap="0"
    fxLayoutGap.xs="5%"
    fxLayoutGap.sm="5%"
    fxLayoutAlign="space-between start"
  >
    <div fxFlex="40" fxFlex.md="30" fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="8%">
      <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5%">
        <p class="default-paragraph color-light-violet">Follow Docformative on:</p>
        <div fxLayout="row">
          <a href="https://www.facebook.com/Docformative/" target="_blank" rel="noopener">
            <img width="100%" height="100%" src="assets/img/home/common/facebook-icon.svg" alt="facebook" />
          </a>
          <a fxFlexOffset="10px" href="https://twitter.com/Docformative" target="_blank" rel="noopener">
            <img width="100%" height="100%" src="assets/img/home/common/twitter-icon.svg" alt="twitter" />
          </a>
          <a fxFlexOffset="10px" href="https://linkedin.com/company/docformative" target="_blank" rel="noopener">
            <img width="100%" height="100%" src="assets/img/home/common/linkedin-icon.svg" alt="linkedin" />
          </a>
          <a fxFlexOffset="10px" href="https://www.instagram.com/docformative" target="_blank" rel="noopener">
            <img width="100%" height="100%" src="assets/img/home/common/instagram-icon.svg" alt="instagram" />
          </a>
        </div>
      </div>
      <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="7%">
        <p class="default-paragraph color-white">Download the Docformative app.</p>
        <div fxLayout="row" fxLayoutAlign="center center">
          <a fxFlex="162px" fxLayout="row" href="https://apps.apple.com/us/app/docformative/id1472933856" target="_blank" rel="noopener">
            <img width="100%" height="100%" fxFlexFill src="assets/img/home/common/app-store-icon.png" alt="app store" />
          </a>
        </div>
      </div>
    </div>
    <div fxFlex="25" fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start start">
      <p class="small-paragraph color-light-violet">Product</p>
      <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
        <a routerLink="/product/healthcare-provider" class="small-paragraph color-white">For Healthcare Professionals</a>
        <a routerLink="/product/pharma-company" class="small-paragraph color-white">For Pharma Companies</a>
      </div>
    </div>
    <div fxFlex="10" fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start start">
      <p class="small-paragraph color-light-violet">Sitemap</p>
      <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
        <a routerLink="/product" class="small-paragraph color-white">Product</a>
        <a routerLink="/about" class="small-paragraph color-white">About Us</a>
        <a routerLink="/news" class="small-paragraph color-white">News</a>
      </div>
    </div>
    <div fxFlex="20" fxFlex.md="25" fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start start">
      <p class="small-paragraph color-light-violet">Others</p>
      <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="5px">
        <a routerLink="/faq" class="small-paragraph color-white">FAQ</a>
        <a routerLink="/terms-and-conditions" class="small-paragraph color-white">Terms & Conditions</a>
        <a routerLink="/privacy-policy" class="small-paragraph color-white">Privacy Policy</a>
      </div>
      <p fxFlexOffset="35%" class="copyright color-light-violet">© {{ currentYear }} Docformative, Inc.</p>
    </div>
  </div>
</footer>
